import React from "react";
import Collab from "../assets/collaboration.png";
import Mention from "../assets/mention.png";
import SkySport from "../assets/skySport.png";
import Royalty from "../assets/royalty.png";
import Admin from "../assets/admin.png";
import Vupop from "../assets/vupop.svg";
import Arrow from "../assets/arrow.svg";
import google from "../assets/Store download button.webp";
import app from "../assets/Store download button (1).webp";
// import NavbarApp from "../components/NavbarApp";
import CookieConsentBanner from "../components/CookieBanner";

export default function LandingPage() {
   const collabRef = React.useRef(null);

  const scrollToCollaborate = () => {
    collabRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className="bg-black text-white w-full overflow-x-hidden ">
   

<section className="relative text-center  px-6 md:px-18 pt-20 sm:pt-10 bg-[radial-gradient(circle_at_center,rgba(248,253,36,0.15),rgba(0,0,0,1)_60%)] overflow-hidden">
  
  <div className="absolute inset-0 pointer-events-none">
    {/* Top-left outline */}
    <div
      className="
        absolute top-[-100px] left-[-150px]
        w-[600px] h-[600px]
        xl:w-[500px] xl:h-[500px]
        lg:w-[400px] lg:h-[400px]
        md:w-[350px] md:h-[350px]
        sm:w-[280px] sm:h-[280px]
        border-[5px]
        rounded-full  border-[#FFFF]/5
      "
    ></div>

    {/* Bottom-right outline */}
    <div
      className="
        absolute bottom-[0px] right-[-180px] 
        w-[700px] h-[700px]
        xl:w-[600px] xl:h-[600px]
        lg:w-[500px] lg:h-[500px]
        md:w-[400px] md:h-[400px] md:bottom-[50px]
        sm:w-[320px] sm:h-[320px] sm:bottom-[80px]
           border-[5px]
        rounded-full  border-[#FFFF]/5
      "
    ></div>
  </div>

  {/* ✅ Keep your gradient background */}
  <div className="absolute inset-0 bg-gradient-to-b from-[#0D0D0D] via-black to-[#0D0D0D] -z-10"></div>

  {/* Content */}
  <h1
    className="
      text-[#F8FD24]
      font-Norwester font-extrabold tracking-wider
      max-w-3xl mx-auto leading-tight mt-10
      text-6xl
      xl:text-5xl
      lg:text-4xl
      md:text-3xl
      sm:text-2xl
    "
    style={{ fontFamily: 'Norwester' }}
  >
    COLLABORATE WITH BROADCASTERS, SHARE YOUR VIDEOS, GET PAID WHEN THEY ARE USED.
  </h1>

  <div className="mt-16 flex justify-center items-center gap-4 sm:gap-2">
      <div
            className="
      flex gap-3 sm:gap-4 md:gap-4 
      justify-start 
      mb-8 sm:mb-10 md:mb-10
    "
          >
            <img
              src={google}
              alt="Google Play"
              className="
      w-[200px]        /* default large */
      xl:w-[180px]     /* <= 1579px */
      lg:w-[150px]     /* <= 1123px */
      md:w-[130px]     /* <= 967px */
      sm:w-[110px]     /* <= 639px */
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share",
                  "_blank"
                )
              }
            />

            <img
              src={app}
              alt="App Store"
              className="
      w-[200px]
      xl:w-[180px]
      lg:w-[150px]
      md:w-[130px]
      sm:w-[110px]
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://apps.apple.com/app/vupop/id6747295116",
                  "_blank"
                )
              }
            />
          </div>
  </div>

  <div className="mt-[5%] flex justify-center">
    <div className="w-[530px] md:w-[550px] h-[470px] sm:h-[300px]  rounded-xl overflow-hidden flex items-end justify-center">
      <img
        src={Collab}
        alt="logo"
        className="w-full h-full object-contain z-10"
      />
    </div>
  </div>
</section>


      <section ref={collabRef} className="m-10  px-4 sm:px-6 md:px-12 lg:px-20 mt-10 sm:mt-16 md:mt-20 pt-10 sm:pt-16 md:pt-20 bg-[#1B1B1C] flex flex-row md:flex-col items-center gap-8 sm:gap-10 md:gap-12 border border-[#1B1B1C] rounded-lg">
        {/* Image Section */}
        <div className="w-full flex justify-center">
          <div className="w-[280px] xs:w-[300px] sm:w-[150px] md:w-[380px] lg:w-[240px] xl:w-[380px] rounded-xl overflow-hidden flex">
            <img
              src={Mention}
              alt="mention"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        <div
          className="
    w-full 
    flex flex-col 
    items-end text-right 
    
    px-4  md:px-0
  "
        >
          <h2
            style={{ fontFamily: "Norwester" }}
            className="
      text-5xl        
      xl:text-4xl     /* <= 1579px */
      lg:text-3xl     /* <= 1123px */
      md:text-2xl     /* <= 967px */
      sm:text-xl      /* <= 639px */
      font-bold tracking-wider mb-4 sm:mb-6 
      text-[#F8FD24]
    "
          >
            COLLABORATE WITH BROADCASTERS
          </h2>

          <p
            style={{ fontFamily: "League Spartan" }}
            className="
      text-xl         
      xl:text-lg      
      lg:text-base    
      md:text-sm      
      sm:text-xs      
      text-gray-300 leading-relaxed 
      max-w-md sm:max-w-sm mb-6 sm:mb-8 md:mb-10
    "
          >
            Tag the brands, broadcasters, or teams you want to see your content.
            Build your profile as a creator and connect your clips with the
            brands and broadcasters who matter most to you.
          </p>

          <div
            className="
    flex items-center 
    gap-3 sm:gap-3 md:gap-4 
    justify-end sm:justify-start 
    mb-8 sm:mb-10 md:mb-10
  "
          >
            <img
              src={google}
              alt="Google Play"
              className="
      w-[200px]        /* default large */
      xl:w-[180px]     /* <= 1579px */
      lg:w-[150px]     /* <= 1123px */
      md:w-[130px]     /* <= 967px */
      sm:w-[70px]     /* <= 639px */
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share",
                  "_blank"
                )
              }
            />

            <img
              src={app}
              alt="App Store"
              className="
      w-[200px]
      xl:w-[180px]
      lg:w-[150px]
      md:w-[130px]
      sm:w-[70px]
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://apps.apple.com/app/vupop/id6747295116",
                  "_blank"
                )
              }
            />
          </div>
        </div>
      </section>

      {/* Feature 2 */}
      <section className=" m-10  px-4 sm:px-6 md:px-12 lg:px-20 mt-10 sm:mt-16 md:mt-20 pt-10 sm:pt-16 md:pt-20 bg-[#1B1B1C] flex flex-row md:flex-col items-center gap-8 sm:gap-10 md:gap-12 border border-[#1B1B1C] rounded-lg">
        {/* TEXT SECTION */}
        <div
          className="
    w-full 
    flex flex-col 
    items-start text-left 
    px-4  md:px-0 
    sm:items-start
  "
        >
          <h2
            style={{ fontFamily: "Norwester" }}
            className="
      text-[#F8FD24]
      text-5xl        /* ✅ largest default */
      xl:text-4xl     /* <= 1579px */
      lg:text-3xl     /* <= 1123px */
      md:text-2xl     /* <= 967px */
      sm:text-xl      /* <= 639px */
      font-bold tracking-wide mb-4 
    "
          >
            CHAT & COLLABORATE LIVE WITH BROADCASTERS
          </h2>

          <p
            style={{ fontFamily: "League Spartan" }}
            className="
      text-gray-300
      text-xl
      xl:text-lg
      lg:text-base
      md:text-sm
      sm:text-xs
      leading-relaxed 
       mb-8
    "
          >
            Join the conversation while events unfold. Share videos, vote in
            polls, and chat with fans and broadcasters in real time — turning
            moments into shared experiences.
          </p>

          <div
            className="
      flex gap-3 sm:gap-4 md:gap-4 
      justify-start 
      mb-8 sm:mb-10 md:mb-10
    "
          >
            <img
              src={google}
              alt="Google Play"
              className="
      w-[200px]        /* default large */
      xl:w-[180px]     /* <= 1579px */
      lg:w-[150px]     /* <= 1123px */
      md:w-[130px]     /* <= 967px */
      sm:w-[70px]     /* <= 639px */
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share",
                  "_blank"
                )
              }
            />

            <img
              src={app}
              alt="App Store"
              className="
      w-[200px]
      xl:w-[180px]
      lg:w-[150px]
      md:w-[130px]
      sm:w-[70px]
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://apps.apple.com/app/vupop/id6747295116",
                  "_blank"
                )
              }
            />
          </div>
        </div>

        {/* IMAGE SECTION */}
        <div className="w-full flex justify-center">
          <div className="w-[280px] xs:w-[300px] sm:w-[150px] md:w-[380px] lg:w-[240px] xl:w-[380px] rounded-xl overflow-hidden flex">
            <img
              src={SkySport}
              alt="broadcast"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>
      </section>

      {/* Feature 3 */}
      <section className="m-10 mb-0  px-4 sm:px-6 md:px-12 lg:px-20 mt-10 sm:mt-16 md:mt-20 pt-10 sm:pt-16 md:pt-20 bg-[#1B1B1C] flex flex-row md:flex-col items-center gap-8 sm:gap-10 md:gap-12 border border-[#1B1B1C] rounded-lg">
        {/* Image Section */}
        <div className="w-full flex justify-center">
          <div className="w-[280px] xs:w-[300px] sm:w-[150px] md:w-[380px] lg:w-[240px] xl:w-[380px] rounded-xl overflow-hidden flex">
            <img
              src={Royalty}
              alt="mention"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        <div
          className="w-full 
    flex flex-col 
    items-end text-right 
    
    px-4  md:px-0"
        >
          <h2
            className="
      text-[#F8FD24] 
      text-5xl         
      xl:text-4xl       /* <= 1579px */
      lg:text-3xl       /* <= 1123px */
      md:text-2xl       /* <= 967px */
      sm:text-xl        /* <= 639px */
      font-bold mb-4 tracking-wider
    "
            style={{ fontFamily: "Norwester" }}
          >
            ROYALTY PAYOUTS
          </h2>

          <p
            className="
      text-xl         
      xl:text-lg      
      lg:text-base    
      md:text-sm      
      sm:text-xs      
      text-gray-300 leading-relaxed 
      max-w-md sm:max-w-sm mb-6 sm:mb-8 md:mb-10
    "
            style={{ fontFamily: "League Spartan" }}
          >
            Every time your clip is licensed, you get paid. Vupop tracks your
            royalties automatically, with real-time notifications so you always
            know when your creativity is earning for you.
          </p>

          <div
            className="
    flex items-center 
    gap-3 sm:gap-3 md:gap-4 
    justify-end sm:justify-center 
    mb-8 sm:mb-10 md:mb-10
  "
          >
            <img
              src={google}
              alt="Google Play"
              className="
      w-[200px]        /* default large */
      xl:w-[180px]     /* <= 1579px */
      lg:w-[150px]     /* <= 1123px */
      md:w-[130px]     /* <= 967px */
      sm:w-[70px]     /* <= 639px */
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share",
                  "_blank"
                )
              }
            />

            <img
              src={app}
              alt="App Store"
              className="
      w-[200px]
      xl:w-[180px]
      lg:w-[150px]
      md:w-[130px]
      sm:w-[70px]
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://apps.apple.com/app/vupop/id6747295116",
                  "_blank"
                )
              }
            />
          </div>
        </div>
      </section>

      <section className="text-center p-10 px-6 md:px-11 pt-[7%] bg-[radial-gradient(circle_at_center,rgba(248,253,36,0.15),rgba(0,0,0,1)_40%)]">
        <h1
          className="
    text-[#F8FD24]
    font-Norwester font-extrabold tracking-wider
    max-w-3xl mx-auto leading-tight mt-10

    text-6xl       
    xl:text-5xl    /* <= 1579px */
    lg:text-4xl    /* <= 1123px */
    md:text-3xl    /* <= 967px */
    sm:text-2xl    /* <= 639px */
  "
          style={{ fontFamily: "Norwester" }}
        >
          Enabling Your Fandom, Connecting you into the Action, Putting Money in your pocket
        </h1>

        <p
          className="
    text-gray-300 max-w-xl mx-auto mt-4

    text-xl        /* base large screen */
    xl:text-lg
    lg:text-base
    md:text-sm
    sm:text-xs
  "
          style={{ fontFamily: "League Spartan" }}
        >
          Tell Your Story, Share Your View, and Give Your Analysis on the Action
        </p>

<div
  className="
    mt-16 flex justify-center items-center gap-4
    sm:gap-2
  "
>
 
            <img
              src={google}
              alt="Google Play"
              className="
      w-[200px]        /* default large */
      xl:w-[180px]     /* <= 1579px */
      lg:w-[150px]     /* <= 1123px */
      md:w-[130px]     /* <= 967px */
      sm:w-[110px]     /* <= 639px */
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/details?id=com.app.vupop&pcampaignid=web_share",
                  "_blank"
                )
              }
            />

            <img
              src={app}
              alt="App Store"
              className="
      w-[200px]
      xl:w-[180px]
      lg:w-[150px]
      md:w-[130px]
      sm:w-[110px]
      h-auto 
      cursor-pointer 
      hover:opacity-90 
      transition-all 
      duration-300
    "
              onClick={() =>
                window.open(
                  "https://apps.apple.com/app/vupop/id6747295116",
                  "_blank"
                )
              }
            />
          </div>


      </section>
      <div className="mt-[6%] flex justify-center">
        <div
          className="

      w-full max-w-[950px] 
      rounded-xl overflow-hidden flex items-end justify-center
    "
        >
          <img
            src={Admin}
            alt="logo"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>

      <section className=" bg-black text-left">
        {/* <div
          className=" px-6
      border-b border-b-[#F8FD24]
      flex justify-between items-center
      pt-10 pb-10 p-3 
      xl:flex-row lg:flex-row md:flex-row sm:flex-row   sm:gap-6
    "
        >
          <a
            onClick={(e) => {
              e.preventDefault();
              window.open(
                "https://mail.google.com/mail/?view=cm&fs=1&to=contact@vupop.io",
                "_blank"
              );
            }}
            className="
        text-[#F8FD24] underline cursor-pointer flex items-center
        text-6xl       
        xl:text-5xl    
        lg:text-4xl    
        md:text-4xl     
        sm:text-3xl     
        tracking-wide
      "
            style={{ fontFamily: "Norwester" }}
          >
            Contact Us
          </a>

          <img
            src={Arrow}
            alt="arrow"
            onClick={(e) => {
              e.preventDefault();
              window.open(
                "https://mail.google.com/mail/?view=cm&fs=1&to=contact@vupop.io",
                "_blank"
              );
            }}
            className="
    bg-[#F8FD24] 
    rounded-full 
    cursor-pointer 
    hover:opacity-90 
    transition-all 
    w-[80px] h-[80px] p-6    
    xl:w-[70px] xl:h-[70px] xl:p-5
    lg:w-[60px] lg:h-[60px] lg:p-4
    md:w-[55px] md:h-[55px] md:p-3
    sm:w-[45px] sm:h-[45px] sm:p-2
      "
          />
        </div> */}

        <div className="w-full overflow-hidden mt-6">
          <img src={Vupop} alt="Logo" className="object-cover w-full h-auto" />
        </div>
      </section>
          <CookieConsentBanner/>
    </div>

  );
}
